module.exports = __webpack_public_path__ + "static/img/trash.2d700260.png";